import { useManageFormComments } from 'pages/FormProcess/DynamicForm/Containers/DynamicViewer/components/FieldRenderer/FormComments/hooks/useManageFormComments';
import { useMemo } from 'react';
import _ from 'lodash';

import { useDispatch, useSelector } from 'react-redux';
import { getDynamicFormSelector } from 'store/selectors/requestFormProcess';

import { updateDynamicFormActiveQuestionEffect } from 'store/effects/formProcess';
import { CommentsList } from 'pages/FormProcess/components/CommentsList';

export const FormCommentsListWrapper = ({ scale }) => {
  const { formsComments, commentUsers, commentActions } = useManageFormComments();

  const { bundleDocumentsDetails = [], hoveredFieldUUID = '' } =
    useSelector(getDynamicFormSelector);

  const dispatch = useDispatch();

  const unResolvedThreads = useMemo(() => {
    const threads = {};
    for (let key in formsComments) {
      let unResolved = formsComments[key].filter((item) => !item.Resolved && item.Comments.length);

      unResolved = unResolved.map((item) => ({
        ...item,
        fieldUUID: item.Meta.questionUUID,
        fieldId: item.Meta.fieldId,
      }));

      threads[key] = unResolved;
    }

    return threads;
  }, [formsComments]);

  const onHighlightThread = (fieldUUID) => {
    const element = document.querySelector(`[id^="question-${fieldUUID}-"]`) as HTMLElement;

    if (element) {
      const [_, documentIndex] = element.id.split(`question-${fieldUUID}-`);

      const isCohesiveFlow = bundleDocumentsDetails.length > 0 && +documentIndex >= 0;

      dispatch(
        updateDynamicFormActiveQuestionEffect({
          uuid: fieldUUID,
          documentIndex,
          isCohesiveFlow,
        }),
      );
    }
  };

  if (_.isEmpty(unResolvedThreads)) return <></>;

  return (
    <CommentsList
      listType={'FormComments'}
      threads={unResolvedThreads}
      onHighlightThread={onHighlightThread}
      selectedUUID={hoveredFieldUUID}
      commentUsers={commentUsers}
      commentActions={commentActions}
      listRightOffset={scale}
    />
  );
};
